export const NumericQcFieldName = 'numericQcFieldComponent';
